export interface ProfileUser {
  id: number | string;
  email: string;
  firstname: string;
  lastname: string;
  fullname: string;
  avatar?: string | null;
  google_id?: string | null;
  role?: string;
  is_anonymous?: boolean;
}

export enum AuthLoginActionTypes {
  API_RESPONSE_SUCCESS = '@@auth/login/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR   = '@@auth/login/API_RESPONSE_ERROR',
  SESSION_CHECK        = 'SESSION_CHECK',
  LOGOUT_USER          = '@@auth/login/LOGOUT_USER',
}

export interface AuthLoginState {
  profile_user: ProfileUser | null;
  error: string;
  loading: boolean;
  isUserLogin: boolean;
  isUserLogout: boolean;
  sessionChecked: boolean;
}
